import { render, staticRenderFns } from "./headerBox.vue?vue&type=template&id=083fa7e6&scoped=true&"
import script from "./headerBox.vue?vue&type=script&lang=js&"
export * from "./headerBox.vue?vue&type=script&lang=js&"
import style0 from "./headerBox.vue?vue&type=style&index=0&id=083fa7e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083fa7e6",
  null
  
)

export default component.exports